import { useEffect, useCallback } from 'react'
import { ThemeProvider } from 'react-jss'
import { useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import GeneralContext from '@/context'
import ScrollbarContext from '@/context/scrollbar'
import MouseContext from '@/context/mouse'
import Handlers from '@/components/Handlers'
import useWillMount from '@/hooks/useWillMount'
import Routes from '@/router'
import Layout from '@/layout'
import actions from '@/actions'
import { theme } from './style'

const App = () => {
  const routes = useSelector((state) => state.routing.route)

  const dispatch = useDispatch()
  const getRouting = useCallback(() => dispatch(actions.routing.getRouting()), [dispatch])
  const updateRouting = useCallback((data) => dispatch(actions.routing.updateRouting(data)), [dispatch])
  const getString = useCallback(() => dispatch(actions.language.getString()), [dispatch])
  const setQuery = useCallback((data) => dispatch(actions.mediaQuery.setQuery(data)), [dispatch])
  const setQueryKey = useCallback((data) => dispatch(actions.mediaQuery.setQueryKey(data)), [dispatch])
  const getMainMenu = useCallback(() => dispatch(actions.nav.getMainMenu()), [dispatch])
  const getMenu = useCallback((data) => dispatch(actions.nav.getMenu(data)), [dispatch])
  const getTaxonomiesList = useCallback((data) => dispatch(actions.page.getAllTerms(data)), [dispatch])

  useWillMount(() => {
    if (window.routing) {
      updateRouting(window.routing)
    } else {
      getRouting()
    }
    getMainMenu()
    getMenu('extra_menu')
    getMenu('contact_menu')
    getMenu('header_menu')
    getMenu('footer_menu')
    getString()
    getTaxonomiesList('_cta_service_category')
    getTaxonomiesList('_cta_store_category')
    getTaxonomiesList('categories')
  })

  const setMQ = () => {
    if (window.matchMedia) {
      const medias = []
      const mediasInverse = []
      const mediaRange = []
      Object.entries(theme.media).map((item) => {
        const value = item[1]
        medias.push(value.replace('@media ', ''))
        return false
      })
      Object.entries(theme.mediaInverse).map((item) => {
        const value = item[1]
        mediasInverse.push(value.replace('@media ', ''))
        return false
      })
      Object.entries(theme.media).map((item, i) => {
        const key = item[0]
        mediaRange[key] = `${medias[i]} and ${mediasInverse[i]}`
        const setMedia = () => {
          if (medias[key].matches) {
            setQuery(key)
            setQueryKey(i)
          }
        }
        medias[key] = window.matchMedia(mediaRange[key])
        medias[key].addListener(() => {
          setMedia()
        })
        setMedia()
        return false
      })
    }
    return this
  }

  useEffect(() => {
    setMQ()
  }, [])

  return routes.length > 0 && (
    <ThemeProvider theme={theme}>
      <Handlers>
        <GeneralContext>
          <MouseContext>
            <ScrollbarContext>
              <Layout>
                <Routes routes={routes} />
              </Layout>
            </ScrollbarContext>
          </MouseContext>
        </GeneralContext>
      </Handlers>
    </ThemeProvider>
  )
}

export default withRouter(App)
